// extracted by mini-css-extract-plugin
export default {"page":"notice_page__x5fNo","notice":"notice_notice__lcmgp","icon":"notice_icon__anI2y","title":"notice_title__2Ni86","text":"notice_text__nGmNc"};